/* eslint-disable @typescript-eslint/no-use-before-define,@typescript-eslint/no-unused-vars */
import { combine, createEffect, createEvent, createStore } from 'effector'

import connectLocalStorage from 'effector-localstorage'
import { APIError } from '../../core/api/Result'
import {
  GetAuthRes,
  GetGeoStatsRes,
  GetMyRes,
  GetMyStoriesRes,
  GetPassportRes,
  GetReferralStatisticsRes,
  GetReferralsRes,
  GetSearchRes,
  GetStatsRes,
  GetUsersByGeoRes,
  GetUsersPreviewsRes,
  PatchPassportRes,
  PatchPasswordRes,
  PostInviteLinkRes,
  PostPassportRes,
  PostVerificationRes,
  PutParentRes,
  Referral,
  UserAPI,
  GetUsersPreviewsReq,
  Stories,
} from '../../services/api/User'
import { Common } from '../../shared/enum'
import { localStorage } from '../../utils'
import { $getLogoutFx } from '../Auth/event'
import {
  clearSearchReferralFx,
  clearUsersPreviews,
  getAuthFx,
  getGeoStatsFx,
  getMyFx,
  getMyStoriesFx,
  getPassportFx,
  getPublicGeoStatsFx,
  getReferralStatisticsFx,
  getReferralsFx,
  getSearchReferralFx,
  getStatsFx,
  getUsersByGeoFx,
  getUsersPreviewsFx,
  patchMyFx,
  patchPassportFx,
  patchPasswordFx,
  postInviteLinkFx,
  postMyEmailFx,
  postPassportFx,
  postVerificationFx,
  putParentFx,
  setReferralsTree,
  setReferralsTreeCount,
  setViewedStoriesFx,
} from './event'

const myLocalStorage = connectLocalStorage('my/my-v1.1')
export const $my = createStore<GetMyRes | null>(myLocalStorage.init() || null)
  .on(getMyFx.done, (_, { result }) => {
    localStorage.set(Common.MY, result.data.data)
    return result.data.data
  })
  .on(patchMyFx.done, (_, { result }) => result.data.data)
$my?.watch(myLocalStorage)
export const $myLoading = createStore<boolean>(false).on(getMyFx.pending, (_, pending) => {
  const my = $my.getState()
  return pending && !my
})

export const $myEmail = createStore<any | null>(null).on(postMyEmailFx.done, (_, { result }) => result.data)
export const $myEmailLoading = createStore<boolean>(false).on(postMyEmailFx.pending, (_, pending) => pending)

export const $myEmailError = createStore<APIError | null>(null)
  .on(postMyEmailFx.fail, (_, { error }) => error.data)
  .on(postMyEmailFx, () => null)

export const $myPatchLoading = createStore<boolean>(false).on(patchMyFx.pending, (_, pending) => pending)

const passportLocalStorage = connectLocalStorage('my/passport')
export const $passport = createStore<Partial<GetPassportRes>>(passportLocalStorage.init() || {}).on(
  getPassportFx.done,
  (_, { result }) => result.data.data || {},
)
$passport.watch(passportLocalStorage)

export const $postPassport = createStore<Partial<PostPassportRes>>({}).on(
  postPassportFx.done,
  (_, { result }) => result.data.data,
)
export const $postPassportLoading = createStore<boolean>(false).on(postPassportFx.pending, (_, pending) => pending)

export const $patchPassport = createStore<Partial<PatchPassportRes>>({}).on(
  patchPassportFx.done,
  (_, { result }) => result.data.data,
)
export const $patchPassportLoading = createStore<boolean>(false).on(patchPassportFx.pending, (_, pending) => pending)

export const $postVerification = createStore<Partial<PostVerificationRes>>({}).on(
  postVerificationFx.done,
  (_, { result }) => result.data.data,
)
export const $postVerificationLoading = createStore<boolean>(false).on(
  postVerificationFx.pending,
  (_, pending) => pending,
)

export const $stats = createStore<Partial<GetStatsRes>>({}).on(getStatsFx.done, (_, { result }) => result.data.data)
export const $statsLoading = createStore<boolean>(false).on(getStatsFx.pending, (_, pending) => pending)

export const $myReferrals = createStore<Partial<GetReferralsRes>>({}).on(
  getReferralsFx.done,
  (_, { result }) => result.data.data,
)
export const $myReferralsLoading = createStore<boolean>(false).on(getReferralsFx.pending, (_, pending) => pending)

export const $myReferralStatistics = createStore<GetReferralStatisticsRes>([]).on(
  getReferralStatisticsFx.done,
  (_, { result }) => result.data.data.sort((a, b) => b.transactionSumPercentage - a.transactionSumPercentage),
)
export const $myReferralStatisticsLoading = createStore<boolean>(false).on(
  getReferralStatisticsFx.pending,
  (_, pending) => pending,
)

export const $getGeoStats = createStore<GetGeoStatsRes[]>([])
  .on(getGeoStatsFx.done, (_, { result }) => result.data.data)
export const $getGeoStatsLoading = createStore<boolean>(false)
  .on(getGeoStatsFx.pending, (_, pending) => pending)

export const $getGeoStatsPublic = createStore<GetGeoStatsRes[]>([])
  .on(getPublicGeoStatsFx.done, (_, { result }) => result.data.data)
export const $getGeoStatsPublicLoading = createStore<boolean>(false)
  .on(getPublicGeoStatsFx.pending, (_, pending) => pending)

export const $getUsersByGeo = createStore<Partial<GetUsersByGeoRes>>({})
  .on(getUsersByGeoFx.done, (_, { result }) => result.data.data)
export const $getUsersByGeoLoading = createStore<boolean>(false)
  .on(getUsersByGeoFx.pending, (_, pending) => pending)

export const $getSearchReferral = createStore<Partial<GetSearchRes>>({})
  .on(getSearchReferralFx.done, (_, { result }) => result.data.data)
  .on(clearSearchReferralFx, () => ({}))
export const $getSearchReferralLoading = createStore<boolean>(false).on(
  getSearchReferralFx.pending,
  (_, pending) => pending,
)

export const $putParent = createStore<Partial<PutParentRes>>({}).on(
  putParentFx.done,
  (_, { result }) => result.data.data,
)
export const $putParentError = createStore('').on(putParentFx.fail, (_, { error }) => error.data.message)
export const $putParentLoading = createStore<boolean>(false).on(putParentFx.pending, (_, pending) => pending)

// await
export const $referralsTree = createStore<Record<string, Referral[]>>({}).on(setReferralsTree, (_, payload) => payload)
export const $referralsTreeCount = createStore<number>(0).on(setReferralsTreeCount, (_, payload) => payload)

export const getUsersPreviewsMapFx = createEvent<number>()
const setTimer = createEvent<NodeJS.Timeout>()
const timer = createStore<null | NodeJS.Timeout>(null).on(setTimer, (_, timer) => timer)
export const getUsersPreviewsAPI = createEffect(UserAPI.getUsersPreviews)
export const $usersPreviewsQueueMap = createStore<Map<number, boolean>>(new Map())
  .on(getUsersPreviewsMapFx, (prev, userId) => {
    const map = new Map(prev)
    map.set(userId, false)
    return map
  })
  .on(getUsersPreviewsAPI.done, (prev, { result }) => {
    const map = new Map(prev)
    result.data.data.items.forEach(({ id }) => map.set(id, true))
    return map
  })
  .watch((state) => {
    const prevId = timer.getState()
    if (prevId) {
      clearTimeout(prevId)
    }
    const id = setTimeout(() => {
      const map = new Map(state)
      const data: number[] = []
      map.forEach((value, key) => {
        !value && data.length < 10 && data.push(key)
      })
      data.length &&
        getUsersPreviewsAPI({
          ids: data,
          limit: 10,
          page: 1,
        })
    }, 1000)
    setTimer(id)
  })
export const $usersPreviewsMap = createStore<Map<number, Referral>>(new Map()).on(
  getUsersPreviewsAPI.done,
  (prev, { result }) => {
    const map = new Map(prev)
    result.data.data.items.forEach((user) => {
      map.set(user.id, user)
    })
    return map
  },
)

export const $usersPreviews = createStore<Partial<GetUsersPreviewsRes>>({})
  .on(getUsersPreviewsFx.done, (_, { result }) => result.data.data)
  .on(clearUsersPreviews, () => ({}))
export const $usersPreviewsLoading = createStore<boolean>(false).on(getUsersPreviewsFx.pending, (_, pending) => pending)

export const $patchPassword = createStore<Partial<PatchPasswordRes>>({}).on(patchPasswordFx.done, (_, { result }) => ({
  status: result.data.status,
}))
export const $patchPasswordError = createStore<Partial<APIError>>({}).on(
  patchPasswordFx.fail,
  (_, { error }) => error.data,
)
export const $patchPasswordLoading = createStore<boolean>(false).on(patchPasswordFx.pending, (_, pending) => pending)

export const $getAuth = createStore<GetAuthRes['items']>([])
  .on(getAuthFx.done, (_, { result }) => result.data.data.items)

export const $getAuthLoading = createStore(false).on(getAuthFx.pending, (_, pending) => pending)

const inviteLinkLocalStore = connectLocalStorage('my/invite-link')
export const $inviteLink = createStore<PostInviteLinkRes | null>(inviteLinkLocalStore.init() || null)
  .on(postInviteLinkFx.done, (_, { result }) => result.data.data)
  .on($getLogoutFx.done, () => null)
$inviteLink.watch(inviteLinkLocalStore)

export const $inviteLinkLoading = createStore(false).on(postInviteLinkFx.pending, (_, pending) => pending)

const myAllStoriesLocalStore = connectLocalStorage('my/all-stories')
export const $myAllStories = createStore<GetMyStoriesRes>(myAllStoriesLocalStore.init() || []).on(
  getMyStoriesFx.done,
  (_, { result }) => result.data.data.sort((a, b) => b.id - a.id),
)
$myAllStories.watch(myAllStoriesLocalStore)

const viewedStoriesLocalStore = connectLocalStorage('my/viewed-stories')
export const $viewedStoriesIds = createStore<number[]>(viewedStoriesLocalStore.init() || []).on(
  setViewedStoriesFx,
  (prev, value): number[] => {
    const set = new Set(prev)
    set.add(value)
    return Array.from(set)
  },
)
$viewedStoriesIds.watch(viewedStoriesLocalStore)

interface MyStories {
  new: Stories[]
  viewed: Stories[]
}
export const $myStories = combine($myAllStories, $viewedStoriesIds, (allStories, viewedStories) =>
  allStories.reduce(
    (acc: MyStories, story) => {
      return viewedStories.includes(story.id)
        ? { new: acc.new, viewed: [...acc.viewed, story] }
        : { new: [...acc.new, story], viewed: acc.viewed }
    },
    { new: [], viewed: [] },
  ),
)
